export default class BODCards {
	constructor() {
		this.cards = document.querySelectorAll("[js-bod-card]");
		this.init();
	}

	init() {
		this.cards.forEach((item) => {
			const toggleBtn = item.querySelector("[js-bod-card-toggle]");
			toggleBtn.addEventListener("click", () => this.toggleCard(item, toggleBtn));
		});
	}

	toggleCard(item, btn) {
		const isOpen = btn.getAttribute("aria-expanded") === "true";

		if (isOpen) {
			this.closeCard(item, btn);
		} else {
			this.openCard(item, btn);
		}
	}

	openCard(item, btn) {
		btn.setAttribute("aria-expanded", true);
		item.classList.add("--expanded");
	}

	closeCard(item, btn) {
		btn.setAttribute("aria-expanded", false);
		item.classList.remove("--expanded");
	}
}
